<template>
  <div>
    <el-dialog title="图片剪裁" :visible.sync="dialogVible" append-to-body  :close-on-click-modal="false" width="90%">
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.outputSize" :outputType="option.outputType" :info="option.info" :full="option.full"
            :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :fixed="option.fixed"
            :fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue" :canScale="option.canScale" :fixedBox="option.fixedBox"
            :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVible = false" style="width: 70px; height: 40px">取 消</el-button>
        <el-button type="primary" style="min-width: 70px; height: 40px" @click="finish()" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadUrl_file: "api",
      dialogVible: false,
      // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "png", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 1200, // 默认生成截图框宽度
        // autoCropHeight: 1800, // 默认生成截图框高度
        // fixedBox: true, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        // fixedNumber: [5, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [], // 页面显示的数组
      // 防止重复提交
      loading: false,
      type: "",//上传类型（logo/执照）
      fileName: "",
      reviewPath: "",
    };
  },
  created() {
    //若嵌套页面即window.location有多个"/"，则请求"api"前需要加"../"
    if (this.common.sGetCharCount("/", window.location.href) > 4) { this.reviewPath = "../../"; }
    else if (this.common.sGetCharCount("/", window.location.href) > 3) { this.reviewPath = "../"; }
    else { this.reviewPath = ""; }
  },
  methods: {
    // 这个是对应element的上传
    changeUpload(file, type) {
      this.type = type;
      this.fileName = file.file.name;
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(file.file.name)) {
        this.$message.error({
          message: "图片类型必须是,jpeg,jpg,png中的一种",
          offset: "60",
        });
        return false;
      }
      const isLt5M = file.file.size / 1024 / 1024 < 50;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 50MB");
        return false;
      }
      let data;
      data = URL.createObjectURL(file.file);
      this.option.img = data;
      this.dialogVible = true;
    },
    // 这个是对应上面的 input 的方法
    // changeUpload(e) {
    //   // 上传图片
    //   // this.option.img
    //   var file = e.target.files[0];
    //   if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
    //     this.$message.error({
    //       message: "图片类型必须是,jpeg,jpg,png中的一种",
    //       offset: "60",
    //     });
    //     return false;
    //   }
    //   const isLt5M = file.size / 1024 / 1024 < 5;
    //   if (!isLt5M) {
    //     this.$message.error("上传文件大小不能超过 5MB!");
    //     return false;
    //   }
    //   var reader = new FileReader();
    //   reader.onload = (e) => {
    //     let data;
    //     if (typeof e.target.result === "object") {
    //       // 把Array Buffer转化为blob 如果是base64不需要
    //       data = window.URL.createObjectURL(new Blob([e.target.result]));
    //     } else {
    //       data = e.target.result;
    //     }
    //     this.option.img = data;
    //     this.dialogVible = true;
    //   };
    //   // 转化为base64
    //   // reader.readAsDataURL(file)
    //   // 转化为blob
    //   reader.readAsArrayBuffer(file);
    // },

    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.loading = true;
      // 输出
      this.$refs.cropper.getCropBlob((data) => {
        let param = new FormData();
        param.append("file", new window.File([data], `.png`));
        this.uploadFile(param);
      });
    },
    //fileUpload
    uploadFile(param) {
      this.$http
        .post(`${process.env.BASE_URL}api/file/upload`, param)
        .then((res) => {
          if (res.data.code == 200) {
            this.$set(res.data, 'name', this.fileName);
            this.$set(res.data, 'type', this.type);
            this.$emit("emitt", res.data);
            this.loading = false;
            this.dialogVible = false;
            this.option.img = "";
          } else {
            this.$message({
              offset: "60",
              type: "error",
              message: "上传失败-" + res.data.msg,
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.cropper-content .cropper {
  width: auto;
  height: 300px;
}
</style>
